module.exports = __webpack_public_path__ + "img/椭圆形.9c29bb87.png";